<template>
  <div>
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/mch/pnc/visit/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/visit/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        🤱 Postnatal Visit
      </a>
      <a
        :href="'/mch/pnc/history/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/history/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        📜 History
      </a>
      <a
        :href="'/mch/pnc/diagnosis/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/diagnosis/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        🩺 Diagnosis
      </a>
      <a
        :href="'/mch/pnc/investigations/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/investigations/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        🔬 Investigations & Lab Results
      </a>
      <a
        :href="'/mch/pnc/prescriptions/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/prescriptions/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        💊 Prescriptions
      </a>
      <a
        :href="'/mch/pnc/notes/' + $route.params.visit_id"
        :class="['tab-link', $route.fullPath == '/mch/pnc/notes/' + $route.params.visit_id ? 'active-tab' : '']"
      >
        📝 Notes
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "pnc_head",
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
.tab-link {
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  text-decoration: none;
  background: white;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.tab-link:hover {
  background: #e6fffa;
  color: #285e61;
}
.active-tab {
  background: linear-gradient(135deg, #319795 0%, #285e61 100%);
  color: white;
  border-color: transparent;
}
</style>
